import { useAuth } from '@/app/context';
import { useEffect, useState } from 'react';

/** Permissão que a API exige em `POST .../charges/regenerate` e `.../charges/manual`. */
export const MANAGE_PAYMENT_CHARGES_PERMISSION = 'policies.charges.manual';

/**
 * Espelha o guard da API (`@RequirePermission('policies.charges.manual')`) para
 * gatear as ações de gerar/regerar link de pagamento na aba Cobrança.
 *
 * É por PERMISSÃO, não por grupo, de propósito: hoje ela é concedida ao perfil
 * financeiro (`insurer.finance`), mas liberar a ação para corretores no futuro
 * passa a ser uma mudança de configuração no Cognito, sem tocar em código —
 * nem aqui, nem na API.
 *
 * Esconder o botão é conveniência, não segurança: a API rejeita a chamada direta
 * de quem não tem a permissão.
 */
export function useCanManagePaymentCharges() {
  const { checkUserPermissions } = useAuth();
  const [canManage, setCanManage] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserPermissions([MANAGE_PAYMENT_CHARGES_PERMISSION]);
      setCanManage(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserPermissions]);

  return { canManage, isLoading };
}
